<script>
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { completemsg, apply } from "../stores.js";

  onMount(async () => {
    window.scroll(0, 0);
    if (!$apply || !$apply.complete) {
      push("/");
    }
  });
</script>

<style>
  .strong {
    font-weight: 700 !important;
  }
</style>

<h2>{$completemsg.header}</h2>
{#each $completemsg.body.paragraphs as paragraph}
<p class="ws-pl">{#each paragraph.parts as part}<span class="{part.class ? part.class : ''}">{part.text}</span>{/each}</p>
{/each}
<h6 class="mt-0">{$completemsg.mailnotice.header}</h6>
<ul class="mt-0">
{#each $completemsg.mailnotice.items as item}
  <li>{item}</li>
{/each}
</ul>
{#each $completemsg.footer.paragraphs as paragraph}
<p class="ws-pl">{#each paragraph.parts as part}<span class="{part.class ? part.class : ''}">{part.text}</span>{/each}</p>
{/each}
